import React, { useEffect, useMemo, useState } from "react";
import Icon from "@mdi/react";
import { mdiTagOutline, mdiPrinter } from "@mdi/js";
import moment from "moment";
import momentLocalizer from "react-widgets-moment";

import { getBranch, getUserLogin } from "utils/utils";
import { pushNotification } from "utils/notifications";
import DatHangDaiLyApi from "../../../service/datHangDaiLyApi";
import DatHangApi from "../../../service/DatHang/DatHangApi";
import TableBaoGiaDaiLy from "./TableBaoGiaDaiLy";
import SearchBaoGiaDaiLy from "./SearchBaoGiaDaiLy";
import ModalChiTietBaoGia from "./ModalChiTietBaoGia";
import ModalTaoDonBaoGia from "./ModalTaoDonBaoGia";

momentLocalizer(moment);

const PAGE_SIZE = 20;

const initCustomer = {
  CustomerID: 0, CustomerName: "", CustomerAddress: "",
  Phone: "", TaxCode: "", NVKD: "", NVKDID: 0, DiaChiGiaoHang: "", SoNgayNo: 0,
};

export default function BaoGiaDaiLy() {
  const [quotes, setQuotes]       = useState([]);
  const [total, setTotal]         = useState(0);
  const [loading, setLoading]     = useState(false);
  const [sMaBaoGia, setSMaBaoGia] = useState("");
  const [tuNgay, setTuNgay]       = useState(moment().subtract(30, "days").format("YYYY-MM-DD"));
  const [denNgay, setDenNgay]     = useState(moment().format("YYYY-MM-DD"));
  const [pageIndex, setPageIndex] = useState(1);

  const [customer, setCustomer] = useState(initCustomer);

  const [detail, setDetail]             = useState(null);
  const [orderModal, setOrderModal]     = useState(null);
  const [orderSelectedIds, setOrderSelectedIds] = useState([]);
  const [orderNote, setOrderNote]       = useState("");
  const [orderExpectedDate, setOrderExpectedDate] = useState(new Date(Date.now() + 60000));
  const [isDateOpen, setIsDateOpen]     = useState(false);
  const [isOrdering, setIsOrdering]     = useState(false);
  const [selected, setSelected] = useState({ key: "11", value: "Tuỳ chỉnh thời gian" });

  useEffect(() => { loadCustomer(); loadData(1); }, []);

  const loadCustomer = () => {
    DatHangApi.getChiTietKhachHangById(getUserLogin().UserName)
      .then((res) => {
        if (res.status === 200)
          setCustomer({
            CustomerID: res.data.CustomerID,
            CustomerName: res.data.CustomerName,
            CustomerAddress: res.data.CustormerAddress,
            Phone: res.data.Phone,
            TaxCode: res.data.TaxCode,
            NVKD: res.data.NVKDUserName,
            NVKDID: res.data.NVKDID,
            DiaChiGiaoHang: res.data.DiaChiGiaoHang,
            SoNgayNo: res.data.SoNgayNo,
          });
      })
      .catch(() => {});
  };

  const resetSearch = () => {
    setSMaBaoGia("");
    setTuNgay(moment().subtract(30, "days").format("YYYY-MM-DD"));
    setDenNgay(moment().format("YYYY-MM-DD"));
    loadData(1);
  };

  const printList = () => {
    window.location.href =
      "/PrintsFile/InDanhSachBaoGia" +
      "?tuNgay="    + tuNgay +
      "&denNgay="   + denNgay +
      "&sMaBaoGia=" + (sMaBaoGia || "");
  };

  const loadData = (page) => {
    const p = page || pageIndex;
    setLoading(true);
    DatHangDaiLyApi.danhSachBaoGiaDaiLy({
      sUserName: getUserLogin().UserName,
      tuNgay:  tuNgay  + "T00:00:00",
      denNgay: denNgay + "T23:59:59",
      iPageIndex: p, iPageSize: PAGE_SIZE, sMaBaoGia,
    })
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setQuotes(res.data?.List || []);
          setTotal(res.data?.iTotal || 0);
          setPageIndex(p);
        } else {
          pushNotification(res.data || "Lỗi tải danh sách báo giá", "error", "TOP_RIGHT", 2000);
        }
      })
      .catch(() => setLoading(false));
  };

  const openDetail = (id) => {
    setDetail({ loading: true, data: null });
    DatHangDaiLyApi.chiTietBaoGiaDaiLy(id, getUserLogin().UserName)
      .then((res) => {
        if (res.status === 200) setDetail({ loading: false, data: res.data });
        else { setDetail(null); pushNotification("Lỗi tải chi tiết", "error", "TOP_RIGHT", 2000); }
      })
      .catch(() => setDetail(null));
  };

  const openOrderModal = (id, maBaoGia) => {
    DatHangDaiLyApi.chiTietBaoGiaDaiLy(id, getUserLogin().UserName)
      .then((res) => {
        if (res.status === 200) {
          const items = res.data?.lstChiTiet || [];
          setOrderModal({ baoGiaId: id, maBaoGia: res.data?.MaBaoGia || maBaoGia, items });
          setOrderSelectedIds(items.map(getItemKey));
          setOrderNote("");
          setOrderExpectedDate(new Date(Date.now() + 60000));
        } else {
          pushNotification("Lỗi tải thông tin báo giá", "error", "TOP_RIGHT", 2000);
        }
      })
      .catch(() => {});
  };

  const getItemKey = (item) => `${item.CategoryID}_${item.OptionID || 0}`;

  const orderSelectedItems = useMemo(
    () => (orderModal ? orderModal.items.filter((i) => orderSelectedIds.includes(getItemKey(i))) : []),
    [orderModal, orderSelectedIds],
  );

  const orderTotalMoney = useMemo(
    () => orderSelectedItems.reduce((s, i) => {
      const p = Number(i.DonGia || 0);
      return p > 0 ? s + p * Number(i.Quantity || 0) : s;
    }, 0),
    [orderSelectedItems],
  );

  const isCheckedAll = useMemo(
    () => !!orderModal && orderModal.items.length > 0 && orderSelectedIds.length === orderModal.items.length,
    [orderModal, orderSelectedIds],
  );

  const toggleAll = (checked) => setOrderSelectedIds(checked ? orderModal.items.map(getItemKey) : []);
  const toggleItem = (key, checked) =>
    checked
      ? setOrderSelectedIds((p) => [...new Set([...p, key])])
      : setOrderSelectedIds((p) => p.filter((x) => x !== key));

  const submitOrder = () => {
    if (isOrdering || !orderModal) return;
    if (!orderSelectedIds.length) {
      pushNotification("Vui lòng chọn sản phẩm đặt hàng", "error", "TOP_RIGHT", 2000);
      return;
    }
    if (!Number(getBranch())) {
      pushNotification("Chưa xác nhận được chi nhánh", "error", "TOP_RIGHT", 2000);
      return;
    }
    if (!Number(customer.CustomerID)) {
      pushNotification("Chưa xác nhận được thông tin đại lý", "error", "TOP_RIGHT", 2000);
      return;
    }

    const now = new Date();
    const fmt = (d) => moment(d).format("YYYY-MM-DD HH:mm:ss");

    const payload = {
      OrderDatHangID: 0, OrderCode: "", CreatedTime: fmt(now), UpdatedTime: fmt(now),
      CreatedUser: getUserLogin().UserName, UpdatedUser: "", Note: orderNote,
      CustomerID: customer.CustomerID, CustomerName: customer.CustomerName,
      CustomerAddress: customer.CustomerAddress, Phone: customer.Phone, TaxCode: customer.TaxCode,
      AccountBank: "", TotalAmount: orderTotalMoney, TotalPaid: 0, TotalPaidOlder: 0,
      StoreExportStatus: 1, IsAddTax: true, DatePaid: fmt(now), OtherFee: 0,
      CustomerDebt: 0, ChietKhau: 0, GiaoHang: true, Approval: 0, BankId: 0, TypeMoney: 0,
      NgayTao: fmt(now), NgayCapNhat: fmt(now), BranchID: getBranch(), ChietKhau_CongThuc: "",
      IsAutoTruKho: false, TrangThaiGiaoNhan: 0, NgayDuKienGiao: fmt(orderExpectedDate),
      IsDuHang: true, TotalAmountThueGTGT: 0, IsLayHoaDon: false, ThueGTGT: 0,
      HanThanhToan: null, POCode: "", NVKD: customer.NVKD, NVKDID: customer.NVKDID,
      BranchName: "", IsDoiTac: true, TotalAmountNew: 0, SoNgayNo: customer.SoNgayNo,
      sUserName: getUserLogin().UserName, DiaChiGiaoHang: customer.DiaChiGiaoHang,
      lstChiTiet: orderSelectedItems.map((item) => ({
        CategoryID: item.CategoryID, CategoryName: item.CategoryName,
        OptionID: item.OptionID || 0, OptionName: item.OptionName || "",
        IsMuaGiaCong: !!(item.OptionID), SoLuongMua: Number(item.Quantity || 0),
        CategoryPrice: Number(item.DonGia || 0), Price: Number(item.DonGia || 0),
        TenDonViXuat: item.DisplayName || "",
        UnitForExportPrice: item.UnitForExportPrice || item.CategoryUnitForExportPriceId || 0,
        SaleTime: fmt(now), Quantity: 1, ValueOfUnitForExportPrice: Number(item.Quantity || 0),
      })),
    };

    setIsOrdering(true);
    DatHangDaiLyApi.addOrUpdateDatHang(payload)
      .then((res) => {
        if (res.status === 200) {
          DatHangDaiLyApi.ganOrderIdVaoBaoGia(
            getUserLogin().UserName, orderModal.baoGiaId, res.data,
          ).catch(() => {});
          pushNotification("Tạo đơn đặt hàng thành công", "success", "TOP_RIGHT", 2000);
          setOrderModal(null);
          loadData(1);
        } else {
          pushNotification(res.data || "Có lỗi xảy ra khi đặt hàng", "error", "TOP_RIGHT", 4000);
        }
        setIsOrdering(false);
      })
      .catch(() => {
        setIsOrdering(false);
        pushNotification("Có lỗi xảy ra khi đặt hàng", "error", "TOP_RIGHT", 4000);
      });
  };

  return (
    <div className="don-page">

      {/* Header — giống DonDatHang */}
      <div className="order-header-v2">
        <div className="order-title-v2">
          <span className="order-title-icon-v2">
            <Icon path={mdiTagOutline} size={1.2} />
          </span>
          <span>Báo giá</span>
        </div>

        <div className="order-search-v2">
          <SearchBaoGiaDaiLy
            sMaBaoGia={sMaBaoGia} setSMaBaoGia={setSMaBaoGia}
            tuNgay={tuNgay} setTuNgay={setTuNgay}
            denNgay={denNgay} setDenNgay={setDenNgay}
            selected={selected} setSelected={setSelected}
            onSearch={() => loadData(1)}
            onReset={resetSearch}
          />
        </div>

        <button className="order-print-btn-v2" onClick={printList}>
          <Icon path={mdiPrinter} size={1.2} />
          In
        </button>
      </div>

      {/* Table */}
      <TableBaoGiaDaiLy
        quotes={quotes}
        total={total}
        loading={loading}
        pageIndex={pageIndex}
        onPageChange={loadData}
        onOpenDetail={openDetail}
        onOpenOrder={openOrderModal}
      />

      <ModalChiTietBaoGia detail={detail} onClose={() => setDetail(null)} />

      <ModalTaoDonBaoGia
        orderModal={orderModal}
        onClose={() => setOrderModal(null)}
        isOrdering={isOrdering}
        orderSelectedIds={orderSelectedIds}
        toggleItem={toggleItem}
        isCheckedAll={isCheckedAll}
        toggleAll={toggleAll}
        getItemKey={getItemKey}
        orderTotalMoney={orderTotalMoney}
        orderNote={orderNote}
        setOrderNote={setOrderNote}
        orderExpectedDate={orderExpectedDate}
        setOrderExpectedDate={setOrderExpectedDate}
        isDateOpen={isDateOpen}
        setIsDateOpen={setIsDateOpen}
        submitOrder={submitOrder}
      />

    </div>
  );
}
